import M_BRIDGE from '../components/bridge/index.js'
import M_ENV from '../../main/components/env/index.js'
import M_AXIOS from '../../main/components/axios/index.js'
import M_URL from '../components/url/index.js'
import M_COOKIE from '../../main/components/cookie/index.js'
import {G_ERROR_CODE_MAP} from '../../config/index.js'
import M_MONITOR_REPORT from '../../main/components/monitor/index.js'
// 策略类
class Strategy {
    constructor (){
       
    }

    /**
     * @description: 外部执行方法
     * @param {String} cmd 指令
     * @param {Object} main 外部实例
     * @param {Object} params 传入参数
     * @return {Promise}
     */    
    execute (cmd, main, params){
        switch (cmd) {
            case 'init': // 初始化
                return this.initStrategy(main, params)
            default:
                break
        }
    }
    
    /**
     * 初始化策略
     * @param {Object} instance 外部实例
     * @return {Promise}
     */
    initStrategy (instance) {
        let url = M_URL.getCrtUrl()

        return new Promise((resolve) => {
            // APP内通过js-sdk 获取策略下发
            if (M_ENV.isInApp) {
                M_BRIDGE.invoke('getReportStrategy', {
                    params: {
                        pageId: instance.pageId
                    },
                    callback: (res) => {
                        let { data, retcode, retmsg } = res || {}

                        // 成功
                        // 成功时返回业务策略 + 全局策略
                        // 全局策略key为：
                        if (+retcode === 0) {
                            instance.tracelessSwitch = +data.start_traceless === 1
                            instance.mainSwitch = +data.start_collecting === 1
                            instance.reportSwitch = +data.start_report === 1
                            instance.globalStrategy = data.globalStrategy || {} // 全局策略返回
                        } else {
                            // 失败时发送监控告警 并返回
                            M_MONITOR_REPORT.errorReport({
                                error_log_info: {
                                    error_code: G_ERROR_CODE_MAP.strategy,
                                    error_desc: retmsg
                                }
                            })
                        }
                        // 失败则不处理
                        resolve()
                    }
                })
            } else { // APP外通过接口下发
                M_AXIOS.post('https://dc.fenqile.com/route0031/reportStrategy/queryWebStrategy.json', { 
                    data: {
                        url: url || '',
                        pageId: instance.pageId || '',
                        uid: M_COOKIE.get('uid') || ''
                    }
                }).then((res) => { 
                    let request_data = res.data && res.data.data
                    
                    if (+request_data.result === 0) {
                        let data = request_data.result_rows || {}
                        let logic_strategy = data.strategy || {}
                        let global_strategy = data.globalStrategy || {}

                        instance.tracelessSwitch = +logic_strategy.start_traceless === 1 || false
                        instance.mainSwitch = +logic_strategy.start_collecting === 1 || false
                        instance.reportSwitch = +logic_strategy.start_report === 1 || false
                        instance.globalStrategy = global_strategy // 全局策略返回
                    }
                    resolve()
                }).catch((e) => {
                    // 失败时发送监控告警
                    M_MONITOR_REPORT.errorReport({
                        error_log_info: {
                            error_code: G_ERROR_CODE_MAP.strategy,
                            error_desc: e.toString()
                        }
                    })
                })
            }
        })
    }
    
}

export default new Strategy()